import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';import { AdvisorService } from '../../advisor/advisor.service';
import { AdminListComponent } from './admin-list.component';
import { Option } from '../../../shared/models/option.model';

@Component({
    selector: 'app-assign-advisor-dialog',
    templateUrl: './assign-advisor-dialog.component.html',
    styleUrls: ['./assign-advisor-dialog.component.css'],
    standalone: false
})
export class AssignAdvisorComponent implements OnInit {
  advisorUid: string = null;
  uid: string = this.data.userUid;
  error_msg: string;
  error: boolean = false;
  ready = false;

  advisors = [];

  public get advisorsOptions(): Option[] {
    return (this.advisors || []).map(advisor => ({ label: advisor.name, value: advisor.uid }));
  }

  constructor(
    public advisorService: AdvisorService,
    public dialogRef: MatDialogRef<AdminListComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public snackBar: MatSnackBar,
  ) { }

  ngOnInit() {
    this.advisorService.getList().then(response => {
      this.advisors = response;
      this.ready = true;
    });
  }

  assign() {
    this.advisorService.assignAdvisor({ userUid: this.uid, advisorUid: this.advisorUid }).then(response => {
      this.closeDialog();
    });
  }

  closeDialog() {
    this.dialogRef.close();
  }

  public trackByIndex(i: number) { return i; }

}
